<script setup lang="ts">
const { finalLinkToPromotions, linkToPromotionsTargetBlank } = useLinks();
</script>

<template>
  <NuxtLink
    v-if="finalLinkToPromotions"
    aria-label="Promotions"
    :class="$style.giftIcon"
    :external="linkToPromotionsTargetBlank"
    no-prefetch
    :target="linkToPromotionsTargetBlank ? '_blank' : undefined"
    :to="finalLinkToPromotions"
  >
    <NuxtIcon
      :class="$style.iconMain"
      name="gift"
    />
    <div :class="$style.lightEffect"></div>
  </NuxtLink>
</template>

<style module lang="postcss">
.giftIcon {
  @apply w-[18px] min-w-[18px] h-[18px] md:w-[22px] md:min-w-[22px] md:h-[22px] bg-primary/40 text-texts flex items-center justify-center rounded text-xs md:text-base overflow-hidden relative z-10 bg-[#df7800];

  &:after {
    @apply bg-gradient-to-b from-white/10 to-black/20 content-[''] absolute top-0 left-0 right-0 bottom-0;

    @supports (mix-blend-mode: overlay) {
      @apply mix-blend-overlay;
    }
  }

  &:before,
  .lightEffect,
  .lightEffect:before {
    @apply bg-gradient-to-r from-white/0 via-white/80 to-white/0 content-[''] absolute left-[2%] right-[2%] bottom-0 h-[3px];

    @supports (mix-blend-mode: overlay) {
      @apply mix-blend-overlay;
    }

    @supports (filter: blur(1px)) {
      filter: blur(1px);
    }
  }

  .lightEffect {
    @apply via-white/80 left-[5%] right-[5%];

    @supports (filter: blur(3px)) {
      filter: blur(3px);
    }

    &:before {
      @apply via-white/60 left-[10%] right-[10%] h-[8px] -bottom-[2px];

      @supports (filter: blur(5px)) {
        filter: blur(5px);
      }
    }
  }

  .iconMain {
    @apply relative z-10 drop-shadow-md shadow-black flex p-[3px];
    animation: effect 3000ms linear infinite;

    svg {
      @apply w-full h-full;
    }
  }
}
@keyframes effect {
  0% {
    transform: scale(1);
  }
  60% {
    transform: scale(0.9);
  }
  65% {
    transform: scale(1.1) skew(0.004turn);
  }
  70% {
    transform: scale(1) skew(0.008turn);
  }
  75% {
    transform: scale(1) skew(0);
  }
  77% {
    transform: rotateZ(-15deg);
  }
  79% {
    transform: rotateZ(10deg);
  }
  81% {
    transform: rotateZ(-10deg);
  }
  83% {
    transform: rotateZ(6deg);
  }
  85% {
    transform: rotateZ(-4deg);
  }
}
</style>
